export const ExpFlavorFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: [
        "HELLO,我是你的咖啡好幫手大咖,想挑選最適合你的咖啡風味嗎?找大咖就對了!"
      ]
    },
    {
      type: "select",
      hint: ["最近的天氣超熱的,是不是讓你想來杯超冰拿鐵呢"],
      choices: [
        { label: "我想!", value: 1 },
        { label: "我超想!", value: 2 },
        { label: "買尬無敵想der", value: 3 }
      ],
      afterAnswer: async value => {
        return {
          message: "哈哈哈哈我就知道~"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["平常喜歡喝酸的咖啡嗎?"],
      choices: [
        { label: "我喜歡!", value: 1 },
        { label: "還好耶~", value: 2 },
        { label: "不太喜歡耶...", value: 3 }
      ],
      afterAnswer: async resp => {
        if (resp.value === 1) {
          return {
            message: "我也很喜歡酸味咖啡耶!"
          };
        }
        return {
          message: "原來如此,有時酸味太重真的會讓人難以喜歡"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["原來如此呀,大咖精密分析後發現有一款咖啡超級適合你的"],
      choices: [
        { label: "好想知道噢!", value: 1 },
        { label: "是哪款呢我來瞧瞧", value: 2 },
        { label: "哇!這樣你也知道!", value: 3 }
      ],
      afterAnswer: async idx => {
        let message = "來吧!大咖知道這款咖啡風味你一定會愛!";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      },
      redirectUrl: {},
      results: [
        { answer: "*-1-*", url: "/product/?id=12", label: "fake1&3" },
        { answer: "*-2-*", url: "/product/?id=30", label: "fake1&3" },
        { answer: "*-3-*", url: "/product/?id=30", label: "fake1&3" }
      ]
    }
  ],
  //idx 1 of '/products'
  [
    {
      type: "comment",
      hint: ["HI,我是大咖,想找到你會愛不釋手的咖啡豆嗎,讓我來幫忙你吧!"]
    },
    {
      type: "select",
      hint: ["最近的天氣超熱的,是不是讓你想來杯超冰拿鐵呢"],
      choices: [
        { label: "我想!", value: 1 },
        { label: "我超想!", value: 2 },
        { label: "買尬無敵想der", value: 3 }
      ],
      afterAnswer: async value => {
        return {
          message: "哈哈哈哈我就知道~"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["帶有苦味的咖啡你可以接受嗎?"],
      choices: [
        { label: "我可是天生不吃苦的!", value: 1 },
        { label: "我呀,吃苦當吃補!", value: 2 }
      ],
      afterAnswer: async resp => {
        if (resp.value === 0) {
          return {
            message: "來吧!相信大咖不會讓你吃到半點兒苦頭的"
          };
        }
        return {
          message: "一起吃苦吧!大咖陪你一起苦盡甘來!"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["原來如此呀,大咖精密分析後發現有一款咖啡超級適合你的"],
      choices: [
        { label: "好想知道噢!", value: 1 },
        { label: "是哪款呢我來瞧瞧", value: 2 },
        { label: "哇!這樣你也知道!", value: 3 }
      ],
      afterAnswer: async idx => {
        let message = "來吧!大咖知道這款咖啡風味你一定會愛!";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      },
      redirectUrl: {},
      results: [
        { answer: "*-1-*", url: "/product/?id=28", label: "fake1&3" },
        { answer: "*-2-*", url: "/product/?id=11", label: "fake1&3" }
      ]
    }
  ],
  // idx 2 of '/products'
  [
    {
      type: "comment",
      hint: [
        "你好,我是你的線上專屬咖啡師,大咖,oops!好巧,你也在挑咖啡豆嗎?就讓大咖水水帶著你一起找吧"
      ]
    },
    {
      type: "select",
      hint: ["最近的天氣超熱的,是不是讓你想來杯超冰拿鐵呢"],
      choices: [
        { label: "我想!", value: 1 },
        { label: "我超想!", value: 2 },
        { label: "買尬無敵想der", value: 3 }
      ],
      afterAnswer: async value => {
        return {
          message: "哈哈哈哈我就知道~"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["你平常喝咖啡會加牛奶嗎?"],
      choices: [
        { label: "我都加超多的耶", value: 1 },
        { label: "偶爾加一些", value: 2 },
        { label: "不會!我喜歡純粹喝!", value: 3 }
      ],
      afterAnswer: async resp => {
        if (resp.value === 0) {
          return {
            message: "咖啡加牛奶真的是別有一番風味呢!大咖會挑給你最適合的豆子"
          };
        } else if (resp.value === 1) {
          return {
            message: "哇~看來你可以試試看精品咖啡豆噢!"
          };
        }
        return {
          message: "原來原來!純粹喝的話精品咖啡豆一定很適合你!"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["原來如此呀,大咖精密分析後發現有一款咖啡超級適合你的"],
      choices: [
        { label: "好想知道噢!", value: 1 },
        { label: "是哪款呢我來瞧瞧", value: 2 },
        { label: "哇!這樣你也知道!", value: 3 }
      ],
      afterAnswer: async idx => {
        let message = "來吧!大咖知道這款咖啡風味你一定會愛!";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      },
      redirectUrl: {},
      results: [
        { answer: "*-1-*", url: "/product/?id=8", label: "fake1&3" },
        { answer: "*-2-*", url: "/product/?id=20", label: "fake1&3" },
        { answer: "*-3-*", url: "/product/?id=23", label: "fake1&3" }
      ]
    }
  ],
  // idx 3 of '/products'
  [
    {
      type: "comment",
      hint: ["你好你好,初次見面,讓大咖來給你一些小小福利吧!"]
    },
    {
      type: "select",
      hint: ["最近的天氣超熱的,是不是讓你想來杯超冰拿鐵呢"],
      choices: [
        { label: "我想!", value: 1 },
        { label: "我超想!", value: 2 },
        { label: "買尬無敵想der", value: 3 }
      ],
      afterAnswer: async value => {
        return {
          message: "哈哈哈哈我就知道~"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["如果大咖請你喝一杯咖啡以外的飲料,哪一些是你比較喜歡的口味呢?"],
      choices: [
        { label: "百果齊放水果茶", value: 1 },
        { label: "黑麻麻的熱可可", value: 2 },
        { label: "健康滿分堅果飲", value: 3 },
        { label: "香噴噴的花茶", value: 4 },
        { label: "奶奶種的金吉檸檬茶", value: 5 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "comment",
      hint: ["這些飲料的口味跟咖啡的風味也有異曲同工之妙噢!"]
    },
    {
      type: "select",
      hint: ["原來如此呀,大咖精密分析後發現有一款咖啡超級適合你的"],
      choices: [
        { label: "好想知道噢!", value: 1 },
        { label: "是哪款呢我來瞧瞧", value: 2 },
        { label: "哇!這樣你也知道!", value: 3 }
      ],
      afterAnswer: async idx => {
        let message = "來吧!大咖知道這款咖啡風味你一定會愛!";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      },
      redirectUrl: {},
      results: [
        { answer: "*-1-*", url: "/product/?id=16", label: "fake1&3" },
        { answer: "*-2-*", url: "/product/?id=17", label: "fake1&3" },
        { answer: "*-3-*", url: "/product/?id=24", label: "fake1&3" },
        { answer: "*-4-*", url: "/product/?id=9", label: "fake1&3" },
        { answer: "*-5-*", url: "/product/?id=9", label: "fake1&3" }
      ]
    }
  ]
];

export const ExpPlaceFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["你好!我是大咖,"]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["那麼，你知道世界各地的咖啡豆都有著不同的調性與香味嗎?"],
      choices: [
        { label: "不知道耶!", value: 1 },
        { label: "好想知道噢!", value: 2 },
        { label: "有請大咖告訴我!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "comment",
      hint: [
        "大咖跟你說噢!這邊是大咖幫你整理出來的產地小常識,看完你一定也會成為一位咖啡小達人!"
      ]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/map", label: "fake1&2&3" }]
    }
  ]
];

export const ExpCentralAmericaFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["你好!我是大咖,中美洲的咖啡豆都是經過精挑細選的嚴選好豆噢!"]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["要不要一起試試中美洲嚴選咖啡風味呢?"],
      choices: [
        { label: "哇!當然好!", value: 1 },
        { label: "好哇好哇!", value: 2 },
        { label: "好想噢", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "comment",
      hint: [
        "大咖偷偷跟你說,中美洲地區已成為世界四大咖啡產區之一,中美洲的嚴選咖啡豆喝起來非常優質噢!"
      ]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/product/?id=9", label: "fake1&2&3" }]
    }
  ]
];

export const ExpSouthAmericaFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["hey!我是大咖,找咖啡嗎,讓大咖來幫助你!"]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["讓我們一起來找南美洲出產的優質咖啡風味吧!"],
      choices: [
        { label: "好想試試南美洲的專屬風味呀!", value: 1 },
        { label: "讓我試試!", value: 2 },
        { label: "我的好奇心滿滿!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "comment",
      hint: [
        "南美洲的咖啡真的是別有一番風味耶!大咖來介紹你幾個南美洲最優的咖啡給你!"
      ]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/product/?id=29", label: "fake1&2&3" }]
    }
  ]
];

export const ExpAfricaFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["hello!我是咖啡專業100的大咖,想找咖啡豆問我就對了!"]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["你知道非洲出產的咖啡散發著迷人的果酸嗎?"],
      choices: [
        { label: "當然知道!", value: 1 },
        { label: "哇嗚大咖好崇拜你", value: 2 },
        { label: "好想試試迷人果酸的非洲咖啡!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "comment",
      hint: [
        "大咖跟你說,肯亞的AA級咖啡是非洲咖啡中的極品，質性厚實飽滿，略帶酸性，口味順暢而略帶酒香，一定很適合喜歡果香味的你！"
      ]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/product/?id=23", label: "fake1&2&3" }]
    }
  ]
];

export const ExpAsiaFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["HEY,找亞洲咖啡嗎,讓大咖一起陪你找!"]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["你知道亞洲咖啡富有深沉的風味與濃厚口感嗎?"],
      choices: [
        { label: "好想試試看!", value: 1 },
        { label: "就是這一味!", value: 2 }
      ],
      extra: {
        type: "single-select",
        redirectUrl: {
          1: "/products",
          2: "/stores"
        }
      }
    },
    {
      type: "comment",
      hint: ["大咖告訴你,亞洲咖啡的風味非常厚重,適合喜歡濃醇香的你!"]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/product/?id=7", label: "fake1&2&3" }]
    }
  ]
];

export const ExpMethodFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["嗨!好咖嚴選歡迎你!我是你的線上咖啡師,你可以叫我大咖!"]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: [
        "不同的處理法,就會有不同的咖啡風味!我們一起嚐嚐看適合你的處理法吧"
      ],
      choices: [
        { label: "我喜歡陽光的日曬感!", value: 1 },
        { label: "我想要整天沉浸在水裡,給我水洗咖啡豆!", value: 2 },
        { label: "我最喜歡蜜處理的咖啡了", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "comment",
      hint: ["喜歡這種處理法的你!你一定是個很有品味的人!"]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [
        { answer: "*-1-*", url: "/product/?id=19", label: "fake1&3" },
        { answer: "*-2-*", url: "/product/?id=23", label: "fake1&3" },
        { answer: "*-3-*", url: "/product/?id=9", label: "fake1&3" }
      ]
    }
  ]
];

export const ExpDryFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["HI,我是你專屬咖啡師,可以叫我大咖!"]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: [
        "你知道日曬法是最古老的處理方法嗎，讓我們一起來挑選適合你的日曬咖啡豆吧！"
      ],
      choices: [
        { label: "當然知道", value: 1 },
        { label: "我最喜歡日曬咖啡了", value: 2 },
        { label: "來吧!我最喜歡在陽光下沐浴了", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "comment",
      hint: ["我就知道,我相信你一定會喜歡這款日曬風味的咖啡"]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/product/?id=29", label: "fake1&2&3" }]
    }
  ]
];

export const ExpWashedFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["你好,想聊聊天嗎,好咖嚴選的大咖在這邊陪你"]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: [
        "喜歡水洗法的你知道水洗法是目前最為廣泛使用的處理方式嗎,你想試試看嗎"
      ],
      choices: [
        { label: "當然想", value: 1 },
        { label: "讓我們一起來試試看吧", value: 2 },
        { label: "好的!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "comment",
      hint: ["既然你這麼想要,我就大發慈悲的賞賜你一定會喜歡的咖啡風味!"]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/product/?id=21", label: "fake1&2&3" }]
    }
  ]
];

export const ExpHoneyFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["嗨!好咖嚴選歡迎你!我是你的線上咖啡師,你可以叫我大咖!"]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: [
        "偷偷跟你說蜜處理法的咖啡豆風味較佳，酸味與甜味均衡,想知道大咖最喜歡哪一款蜜處理法咖啡風味嗎?"
      ],
      choices: [
        { label: "好哇!", value: 1 },
        { label: "獨家祖傳配方你一定要告訴我", value: 2 },
        { label: "讓我知道", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "comment",
      hint: ["我也最喜歡蜜處理的咖啡豆了!這款咖啡你一定要試試看"]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/product/?id=20", label: "fake1&3" }]
    }
  ]
];

export const ExpRoastFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["你好~我是大咖,你的咖啡好幫手"]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["想知道什麼是焙度嗎,讓你的專業咖啡師-大咖來告訴你吧!"],
      choices: [
        { label: "到底是什麼!", value: 1 },
        { label: "好想對咖啡有更進一步的了解", value: 2 },
        { label: "我好想知道噢!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "comment",
      hint: ["這邊有一些焙度小常識,可以幫助你挑選到更適合你的咖啡豆噢!"]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/roast", label: "fake1&3" }]
    }
  ]
];

export const ExpRoastLightFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: [
        "hi~歡迎來到好咖嚴選,我是大咖,你的線上專屬咖啡師,想喝淺焙的咖啡找大咖就對了!"
      ]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["讓我們一起來找找淺焙風味的咖啡風味吧!"],
      choices: [
        { label: "好der", value: 1 },
        { label: "當然想", value: 2 },
        { label: "讓我們一起來試試看吧!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "comment",
      hint: ["淺焙風味的咖啡略帶香氣,散發的迷人氣息一定會讓你愛不釋手"]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/product/?id=31", label: "fake1&3" }]
    }
  ]
];

export const ExpRoastMediumFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["hey!我是大咖,想找中焙咖啡和我聊聊準沒錯!"]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: [
        "中焙咖啡適合喜歡口感清爽豐富的你,讓大咖來幫你選出最優質的中焙咖啡吧"
      ],
      choices: [
        { label: "哇!大咖真好!", value: 1 },
        { label: "好想知道會是什麼噢!", value: 2 },
        { label: "告訴我!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "comment",
      hint: ["就知道你最愛的是不會太淺也不會太深的中焙~~~"]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/product/?id=17", label: "fake1&3" }]
    }
  ]
];

export const ExpRoastHeavyFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: [
        "你好,你可以叫我大咖,再找深焙的風味嗎?我們一起來尋找適合你的咖啡風味吧!"
      ]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: [
        "深焙咖啡適合喜歡口感清爽豐富的你,讓大咖來幫你選出最優質的深焙咖啡吧"
      ],
      choices: [
        { label: "哇!大咖真好!", value: 1 },
        { label: "好想知道會是什麼噢!", value: 2 },
        { label: "告訴我!", value: 3 }
      ],
      extra: {
        type: "single-select",
        redirectUrl: {
          1: "/products",
          2: "/stores",
          3: "/find-by-map"
        }
      }
    },
    {
      type: "comment",
      hint: ["深焙咖啡喝起來真的超棒der~~~~~"]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/product/?id=18", label: "fake1&3" }]
    }
  ]
];

export const ExpAromaFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["你好~我是大咖,你的咖啡好幫手"]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["咖啡的風味分成很多種,我們一起來研究研究吧!"],
      choices: [
        { label: "哇!大咖真好!", value: 1 },
        { label: "好想知道會是什麼噢!", value: 2 },
        { label: "告訴我!", value: 3 }
      ],
      extra: {
        type: "single-select",
        redirectUrl: {
          1: "/products",
          2: "/stores",
          3: "/find-by-map"
        }
      }
    },
    {
      type: "comment",
      hint: [
        "就知道你想聽大咖說話,跟你說噢!大咖幫你整理出了所有的咖啡風味給你參考!"
      ]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/aroma", label: "fake1&3" }]
    }
  ]
];

export const ExpAromaFruitFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["嗨你好我是大咖💁🏻♀️看來你喜歡果香風味的咖啡"]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["讓大咖來陪你一起挑選你會喜歡的果香味咖啡好嗎?"],
      choices: [
        { label: "好呀,謝謝大咖", value: 1 },
        { label: "好的,船長!", value: 2 },
        { label: "好der沒問題!", value: 3 }
      ],
      extra: {
        type: "single-select",
        redirectUrl: {
          1: "/products",
          2: "/stores",
          3: "/find-by-map"
        }
      }
    },
    {
      type: "comment",
      hint: ["大咖跟你說!!!這款咖啡明亮中帶有濃烈的果香及花香調。希望你會喜歡!"]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/product/?id=30", label: "fake1&3" }]
    }
  ]
];

export const ExpAromaLandFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["嗨你好我是大咖，我們一起讓咖啡變成一種品味"]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["喜歡大地芬芳的味道嗎,來這邊跟大咖聊聊就對了!"],
      choices: [
        { label: "哇!崇拜", value: 1 },
        { label: "大咖好帥", value: 2 },
        { label: "大咖陪我聊聊", value: 3 }
      ],
      extra: {
        type: "single-select",
        redirectUrl: {
          1: "/products",
          2: "/stores",
          3: "/find-by-map"
        }
      }
    },
    {
      type: "comment",
      hint: ["大咖跟你說!!!大地芬芳的咖啡豆是大咖的最愛。希望也能變成你的最愛!"]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/product/?id=17", label: "fake1&3" }]
    }
  ]
];

export const ExpAromaSmokedFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: [
        "我是你的線上咖啡師,你可以叫我大咖!讓我們一起來找尋生活中的咖啡好夥伴"
      ]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["想試試煙燻風味的咖啡豆嗎,讓大咖來陪你一起挑選!"],
      choices: [
        { label: "哇!大咖真好!", value: 1 },
        { label: "好想知道噢!", value: 2 },
        { label: "告訴我!", value: 3 }
      ],
      extra: {
        type: "single-select",
        redirectUrl: {
          1: "/products",
          2: "/stores",
          3: "/find-by-map"
        }
      }
    },
    {
      type: "comment",
      hint: ["你真是有品味,挑選到最好喝的煙燻風味咖啡豆"]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/product/?id=7", label: "fake1&3" }]
    }
  ]
];

export const ExpAromaFlowerFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["hey!我是大咖,讓我來幫你找到自己喜歡的口味"]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["花果香風味的咖啡分成很多種,我們一起來研究研究吧!"],
      choices: [
        { label: "好呀,謝謝大咖", value: 1 },
        { label: "好的,船長!", value: 2 },
        { label: "好der沒問題!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "comment",
      hint: ["花果香風味的咖啡豆真的好香,試了一定會愛上"]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/product/?id=28", label: "fake1&3" }]
    }
  ]
];

export const ExpAromaBerryFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["hello!我是咖啡專業100的大咖,我來幫你找到屬於你的品味"]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["讓大咖來陪你一起挑選你會喜歡的莓果風味吧!"],
      choices: [
        { label: "好der!", value: 1 },
        { label: "莓果是我的最愛", value: 2 },
        { label: "一生只有莓果一個人!", value: 3 }
      ],
      extra: {
        type: "single-select",
        redirectUrl: {
          1: "/products",
          2: "/stores",
          3: "/find-by-map"
        }
      }
    },
    {
      type: "comment",
      hint: ["莓果風味的咖啡豆真的好香,試了一定會愛上"]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/product/?id=25", label: "fake1&3" }]
    }
  ]
];

export const ExpAromaNutFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: [
        "我是你的線上咖啡師,你可以叫我大咖!讓我們一起來找尋生活中的咖啡好夥伴"
      ]
    },
    {
      type: "select",
      hint: ["你今天過得好不好呢？"],
      choices: [
        { label: "心情很美麗！", value: 1 },
        { label: "不好不壞呢", value: 2 },
        { label: "糟透了!", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["堅果風味的咖啡豆是你的最愛嗎?"],
      choices: [
        { label: "是啊!", value: 1 },
        { label: "我超愛", value: 2 },
        { label: "我這一生只喝堅果風味", value: 3 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "comment",
      hint: [
        "大咖偷偷跟你說!!!堅果風味的咖啡豆是大咖的最愛。希望也能變成你的最愛!"
      ]
    },
    {
      type: "select",
      hint: ["透過分享，讓你的心情變更好：）"],
      choices: [
        { label: "好優～", value: 1 },
        { label: "OK!", value: 2 },
        { label: "勉強看看！", value: 3 }
      ],
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/product/?id=7", label: "fake1&3" }]
    }
  ]
];

export const ExpBodyFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["hey!我是大咖,讓我來幫你找到自己喜歡的口味"]
    },
    {
      type: "select",
      hint: ["你知道醇度分成清淡、適中和濃厚嗎，我們一起來試試吧！"],
      choices: [
        { label: "原來咖啡有這些神奇的分類!", value: 1 },
        { label: "來吧我都喜歡!", value: 2 }
      ],
      extra: {
        type: "single-select",
        redirectUrl: {
          1: "/products",
          2: "/stores"
        }
      }
    },
    {
      type: "comment",
      hint: ["讓大咖來告訴你咖啡的醇度有分成那些吧!"]
    }
  ]
];

export const ExpBodyLightFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["hello!我是咖啡專業100的大咖,我來幫你找到屬於你的品味"]
    },
    {
      type: "select",
      hint: ["清淡風味的咖啡分成很多種,我們一起來研究研究吧!"],
      choices: [
        { label: "清淡還是最棒了", value: 1 },
        { label: "我們一起來研究吧!", value: 2 },
        { label: "哇我們來研究研究唄!", value: 3 }
      ],
      extra: {
        type: "single-select",
        redirectUrl: {
          1: "/products",
          2: "/stores",
          3: "/find-by-map"
        }
      }
    },
    {
      type: "comment",
      hint: [
        "大咖偷偷跟你說!!!清淡風味的咖啡豆是大咖的最愛。希望也能變成你的最愛!"
      ]
    }
  ]
];

export const ExpBodyMediumFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: ["你好~我是大咖,你的咖啡好幫手"]
    },
    {
      type: "select",
      hint: [
        "就知道你最喜歡淡一點又厚一點的醇度,那就是適中的醇度啦,來這邊跟大咖聊聊就對了!"
      ],
      choices: [
        { label: "就知道你最懂我", value: 1 },
        { label: "哇!我最喜歡適中的了!", value: 2 },
        { label: "適中是最棒的啦", value: 3 }
      ],
      extra: {
        type: "single-select",
        redirectUrl: {
          1: "/products",
          2: "/stores",
          3: "/find-by-map"
        }
      }
    },
    {
      type: "comment",
      hint: ["大咖覺得適中的醇度真的好棒,試了一定會愛上"]
    }
  ]
];

export const ExpBodyHeavyFlow = [
  //idx 0 of '/products'
  [
    {
      type: "comment",
      hint: [
        "你好,你可以叫我大咖,找濃厚的咖啡風味嗎?我們一起來尋找適合你的咖啡吧!"
      ]
    },
    {
      type: "select",
      hint: ["濃厚風味的咖啡適合喜歡,讓大咖來幫你選出最優質的中焙咖啡吧"],
      choices: [
        { label: "濃厚還是最棒了", value: 1 },
        { label: "我們一起來研究吧!", value: 2 },
        { label: "哇我們來研究研究唄!", value: 3 }
      ],
      extra: {
        type: "single-select",
        redirectUrl: {
          1: "/products",
          2: "/stores",
          3: "/find-by-map"
        }
      }
    },
    {
      type: "comment",
      hint: ["會選濃厚醇度的你一定很有品味,希望你會喜歡這款有品味的咖啡豆"]
    }
  ]
];
